import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Immutable from "community/immutable";
import "vendor/es6-promise";
import Module from "global/sparta-module-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Utility from "community/module-utils-utility";
import spartaTemplates from "modules/home-loans/services-home-loans-module/2.2.0/js/templates";
import "css!modules/home-loans/services-home-loans-module/2.2.0/css/services-home-loans-module.scss.css";
export default {

  /*
   * @method rates
   * @param {String} url
   * @param {Object} requestPayload
   * @async POST request
   * @description Mortgage & Refinance rate calls
   */
  rates (url, requestPayload, debugData) {
    console.time('RATES_REQUEST');


    if (debugging()) {
      const response = {
        debugging: true,
        rateInputs: requestPayload.rateInputs,
        ...debugData
      };
      console.log('rates debugging success', response);
      return Promise.resolve(response);
    } else {
      return async(url, 'POST', requestPayload)

        .then(response => {
          console.timeEnd('RATES_REQUEST');

          // resolve rates
          return Promise.resolve(response);

        })
        .catch(error => {
          console.timeEnd('RATES_REQUEST');

          // reject error
          return Promise.reject({...error, ...requestPayload});

        });
    }

  },


  /**
   * @method zipcode
   * @param {String} url
   * @param {Object} requestPayload
   */
  zipcode (url, requestPayload) {

    return async(url, 'POST', requestPayload)

      .then(response => {

        // resolve rates
        return Promise.resolve(response);

      })
      .catch(error => {

        // reject error
        return Promise.reject(error);

      });

  },

  /**
   * @method leadsCall
   * @param {String} url
   * @param {Object} requestPayload
   */
  leadsCall (url, requestPayload) {

    return async(url, 'POST', requestPayload)

      .then(response => {

        // resolve rates
        return Promise.resolve({responsePayload: response, requestPayload});

      })
      .catch(error => {

        // reject error
        return Promise.reject({error, requestPayload});

      });

  },

  /**
   * @method leadsPhoneNumberEndpoint
   * @param {String} url
   * @param {String} subCampaignCode
   * @async GET request
   * @desc Will update get leads phone number to display on page
   */
  leadsPhoneNumberEndpoint (url, subCampaignCode, scsCampCode, debugData) { // ReST API does not currently respece scsCampCode parameter
    console.time('LEADS_PHONE_NUMBER_REQUEST');
    if (debugging()) {
      console.log('leads phone number debugging success', debugData);
      return Promise.resolve({debugging: true, ...debugData});
    }

    // make leads phone number request
    return async(`${url}${scsCampCode || subCampaignCode}`, 'GET')

    // if leads phone number is successful
      .then(response => {
        console.timeEnd('LEADS_PHONE_NUMBER_REQUEST');
        return Promise.resolve(response);
      })

      // if leads phone number is failure
      .catch(error => {
        console.timeEnd('LEADS_PHONE_NUMBER_REQUEST');
        return Promise.reject(error);
      });

  },

  /**
   * @method getAffiliateInfo
   * @param {String} url - the url for the AJAX call
   * @param {String} affiliateCode - the affiliate code to pass to the service
   * @param {Object} debugData - mock data to use for debugging
   * @desc Retrieves an affiliate's sub-campaign number and phone number
   */
  getAffiliateInfo(url, affiliateCode, debugData) {
    if (debugging()) {
      console.log('affiliate info debugging success', debugData);
      return Promise.resolve({debugging: true, ...debugData});
    }
    return async(`${url}${affiliateCode}`, 'GET')
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject({error}));
  }

}

function debugging() {
  return spaParams.siteParams.debugging && getParameterByName('debugging') == 'true'
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");

  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * @method async
 * @param {String} url
 * @param {Object} payload
 * @param {String} methodType
 * @returns {*|Promise|d.promise|promise}
 */
function async(url, methodType, payload) {

  return new Promise((resolve, reject) => {

    $.ajax({

      url,

      async: true,
      cache: true,

      dataType: 'JSON',
      type: methodType,

      data: JSON.stringify(payload),
      contentType: "application/json; charset=utf-8",

      /**
       * @method error
       * @param jqXHR
       * @desc If response fails
       */
      error: function (jqXHR) {
        reject(jqXHR);
      },

      /**
       * @method success
       * @param payload
       * @desc If response is success
       */
      success: function (payload) {
        resolve(payload);
      }

    });

  });

}
